/**
 * Signup identity strings and the OTP resend header.
 * Shared strings for signup identity guards. Auth pages import this module
 * directly so they do not pull Better Auth into the browser bundle; the
 * enforcement module imports Better Auth, so pages import these constants
 * from here and leave that module on the server.
 */

export const PHONE_OTP_RESEND_HEADER = "x-garagem-phone-otp-resend";

export const DUPLICATE_MAILBOX_MESSAGE =
  "User already exists. Use another email.";

export const PHONE_OWNED_BY_ANOTHER_ACCOUNT_MESSAGE =
  "Este telefone já está em outra conta. Entre com essa conta para continuar.";
